import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  status: 'loading',
  user: {
    displayName: 'Loading...',
    limit: 20,
  },
  token: '',
  logged: false,
  roles: [],
  claims: [],
}

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    login: (state, action) => {
      state.user = {
        ...action.payload.user,
        uid: action.payload.uid,
      }
      state.user.limit = action.payload.user.limit || 20
      state.status = action.payload.status
      state.token = action.payload.token
      state.roles = action.payload.roles
      state.logged = true
    },
    claims: (state, action) => {
      state.claims = action.payload.claims
    },
    updateProfile: (state, action) => {
      state.user = {
        ...action.payload.updated,
        uid: action.payload.uid,
      }
      state.status = action.payload.status
    },
    updateField: (state, action) => {
      state.user = {
        ...state.user,
        ...action.payload.field,
      }
      state.status = action.payload.status
    },
    authError: (state, action) => {
      state.status = action.payload.status
    },
    setLimit: (state, action) => {
      state.user.limit = action.payload.limit
    },
    logout: (state) => {
      state = initialState
    },
  },
})

export const authAction = authSlice.actions

export const selectAuth = (state) => state.auth

export default authSlice.reducer
